<template>
  <div class="custom-card">
    <div class="flex justify-between">
      <p class="text-sm flex gap-4 items-center">
        Automatically assigning number or numbering patterns to entities like
        routes IDs.
        <span
          class="text-green font-semibold flex gap-2 items-center"
        >
          <img src="@/assets/images/icons/external-link.svg" alt="external link icon" />
          LEARN MORE
        </span>
      </p>
      <router-link :to="{name : 'ReferenceSettings'}">
        <base-button text="Refrence Settings" />
      </router-link>
    </div>
    <h3 class="font-semibold mt-4 mb-2">Modules</h3>
    <el-collapse v-model="selectedModule">
      <el-collapse-item :name="module.name" class="accordion" v-for="module in modules" :key="module.id">
        <template slot="title">{{module.name}}</template>
          <h3 class="text-base font-semibold">Routes</h3>
          <p>These are entities within this module for which automatic numbering can be set.</p>
          <div class="boxes">
            <div class="box">
              <div class="flex items-center gap-4">
                <img src="@/assets/images/icons/green-circle.svg" alt="" />
                <div class="">
                  <h3 class="font-semibold">Route ID</h3>
                  <p class="text-lightGrey">Identification numbering for identifying ROUTES uniquely.</p>
                </div>
              </div>
              <span @click="showViewEntityModal = true" class="cursor-pointer">
                <img src="@/assets/images/icons/edit-box.svg" alt="" />
              </span>
            </div>
            <div class="box">
              <div class="flex items-center gap-4">
                <img src="@/assets/images/icons/cancel.svg" alt="" />
                <div class="">
                  <h3 class="font-semibold">Terminal ID</h3>
                  <p class="text-lightGrey">ID for identifying TERMINALS uniquely..</p>
                </div>
              </div>
              <span>
                <img src="@/assets/images/icons/edit-box.svg" alt="" />
              </span>
            </div>
          </div>
      </el-collapse-item>
    </el-collapse>
    <view-entity-modal :showModal="showViewEntityModal" @close-modal="showViewEntityModal = false"/>
  </div>
</template> 
<script>
import ViewEntityModal from "./Modals/ViewEntityModal"
export default {
  components: {ViewEntityModal},
  data(){
    return {
      showViewEntityModal: false,
      selectedModule: null,
      modules:[]
    }
  },
  methods: {
    async getModules(){
      // this.$router.push({ name: "RolesAndPrivileges" });
      try {
        let response = await this.$_getModules();
        console.log(response);
        // this.logResponse(response);
        this.modules = response.data.modules;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
  mounted() {
    this.getModules()
  }
}
</script>

<style lang="scss" scoped>
.boxes {
  .box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #DAE8F6;
    border-radius: 8px;
    padding: .8rem;
    margin: .8rem 0;
  }
}
</style>